export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";